import { Component, OnInit, Inject } from '@angular/core';
import { EventRoadService } from '../../services/eventRoad.service';
import { Roadbook } from 'src/app/models/roadbook.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface RoadbookCheck {
  active: boolean;
  id: string;
  name: string;
}
export interface DataDialog {
  roadbooks_ids: string[];
}

@Component({
  selector: 'app-roadbook-selector',
  templateUrl: './roadbook-selector.component.html',
  styleUrls: ['./roadbook-selector.component.scss']
})
export class RoadbookSelectorComponent implements OnInit {

  public roadbooks: RoadbookCheck[] = [];

  constructor(
    private roadbookProvider: EventRoadService,
    public dialogRef: MatDialogRef<RoadbookSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: DataDialog
    ) { }

  ngOnInit(): void {
    this.roadbookProvider.getAll().subscribe(data => {
      this.roadbooks = data.map(ri => {
        return {
          active: this.dataDialog.roadbooks_ids.findIndex(rii => rii === ri.id) > -1,
          id: ri.id,
          name: ri.name
        };
      });
    });
  }
  cancel(): void {
    this.dialogRef.close();
  }
  getActives() {
    return this.roadbooks.filter(ri => ri.active).map(ri => ri.id);
  }
}
